import { Decodable } from "./_decodable";

class LayoutProposal extends Decodable {
    id!: number;
    name!: string;
    file!: string;
    isPro!: boolean;
    hasLogo!: boolean;
    hasHeaderImage!: boolean;
    hasHeaderLogo!: boolean;
    hasFooterImage!: boolean;
    hasFooterLogo!: boolean;
    hasFundoDestaque!: boolean;
    hasTextoDestaque!: boolean;
    hasFundoHeader!: boolean;
    hasTextoHeader!: boolean;
    colorDefaultFundoDestaque!: string|null;
    colorDefaultTextoDestaque!: string|null;
    colorDefaultFundoHeader!: string|null;
    colorDefaultTextoHeader!: string|null;
    status!: number;
   
}

class AccountLayoutProposal extends LayoutProposal {
    accountId?: number;
    layoutProposalId?: number;
    accountLayoutProposalId?: number;
    isSystem?: boolean;
    logo?: string;
    headerLogo?: string;
    headerImage?: string;
    footerImage?: string;
    footerLogo?: string;
    fundoDestaque?: string;
    textoDestaque?: string;
    fundoHeader?: string;
    textoHeader?: string;
    fundoDestaqueDark?: string;
    fundoHeaderLight?: string;
    fixedHeader?: boolean;
    fixedFooter?: boolean;
    facePage?: boolean;
    /** ORCA-1957: assinatura "de acordo" no fim do PDF e da impressão (ORCA-1972: padrão desligado) */
    showSignature?: boolean;
    /** ORCA-1789: vendedor, telefone e e-mail do responsável pelo orçamento no bloco da empresa (padrão desligado) */
    showSeller?: boolean;
    generalConditions?: string;
    defaultProposalDescription?: string;
    // ORCA-1955: o Essência guarda as 9 cores dele (capa_fundo, capa_texto...) no mesmo mapa
    layoutColors?: { [layoutId: string]: { fundo_destaque: string, texto_destaque: string, fundo_header: string, texto_header: string, [key: string]: string } };
    /** ORCA-1958: Essência — as 9 cores (paleta padrão no que faltar) e paletas prontas */
    essenciaColors?: { [key: string]: string };
    essenciaPalettes?: { key: string, name: string, colors: { [key: string]: string } }[];
    layoutProposal?: LayoutProposal;
    createdAt?: Date;
    updatedAt?: Date;
}

export { LayoutProposal, AccountLayoutProposal };
